import { Autocomplete, TextField } from '@mui/material';
import customAxios from '../../../utils/customAxios';
import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../../../scss/Components/_modal.scss';
import { GlobalVariables } from '../../../globalVar';
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { getToast } from '../../../utils/toastConfig';
import AssetCatalogFields from '../AssetCatalogFields';

function ModalAUpdate(props) {
  const { notesString } = useTranslationHook();
  const { getAssets, ...modalProps } = props;

  const [visitClients, setVisitClients] = useState([]);
  const [visitClientSites, setVisitClientSites] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [assetDetails, setAssetDetails] = useState({});
  const [retainedEquipmentId, setRetainedEquipmentId] = useState(null);

  useEffect(() => {
    customAxios
      .get(`${GlobalVariables.getURL()}autofillVisits`, {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      })
      .then((response) => {
        setVisitClients(response.data.clients);
      })

      .catch((error) => console.log(error));
  }, []);

  const handleFirstSelection = async (event, value) => {
    if (!value) {
      setSelectedClient(null);
      setSelectedSite(null);
      setVisitClientSites([]);
      setSiteId(null);
      return;
    }

    setSelectedClient(value);
    const clientSites = await getVisitClientSites(value.id);
    setVisitClientSites(clientSites);
    setSelectedSite(null);
    setSiteId(null);
  };

  const getVisitClientSites = async (value) => {
    const response = await customAxios.get(
      `${GlobalVariables.getURL()}listClientSites/${value}`,
      {
        headers: {
          Authorization: 'bearer ' + localStorage.getItem('token'),
        },
      },
    );
    // console.log(response.data)
    return response.data;
  };

  const parseStoredInt = (key) => {
    const rawValue = localStorage.getItem(key);
    if (rawValue === null || rawValue === '') {
      return null;
    }

    const parsedValue = Number.parseInt(rawValue, 10);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  };

  var assetNameDefaultU = localStorage.getItem('assetNameForUPlaceholder');
  var assetDescDefaultU = localStorage.getItem(
    'assetDescriptionForUPlaceholder',
  );
  var assetClientIdDefaultU = parseStoredInt('assetClientIdForUPlaceholder');
  var assetSiteIdDefaultU = parseStoredInt('assetSiteIdForUPlaceholder');

  const [name, setName] = useState(assetNameDefaultU);
  const [description, setDescription] = useState(assetDescDefaultU);
  const [siteId, setSiteId] = useState(assetSiteIdDefaultU);

  useEffect(() => {
    if (!visitClients.length) {
      return;
    }

    const preselectedClient =
      visitClients.find((client) => client.id === assetClientIdDefaultU) ||
      null;

    setSelectedClient(preselectedClient);

    if (!preselectedClient) {
      setVisitClientSites([]);
      setSelectedSite(null);
      return;
    }

    // The client's sites aren't embedded in visitClients, so they're fetched from the API.
    getVisitClientSites(preselectedClient.id).then((sites) => {
      setVisitClientSites(sites);
      const preselectedSite =
        sites.find((site) => site.id === assetSiteIdDefaultU) || null;
      setSelectedSite(preselectedSite);
    });
  }, [visitClients, assetClientIdDefaultU, assetSiteIdDefaultU]);

  const resetFormFields = () => {
    const currentClientId = parseStoredInt('assetClientIdForUPlaceholder');
    const currentSiteId = parseStoredInt('assetSiteIdForUPlaceholder');
    const currentClient =
      visitClients.find((client) => client.id === currentClientId) || null;

    setName(localStorage.getItem('assetNameForUPlaceholder'));
    setDescription(localStorage.getItem('assetDescriptionForUPlaceholder'));
    setSiteId(currentSiteId);
    setSelectedClient(currentClient);
    const details = JSON.parse(
      localStorage.getItem('assetDetailsForUpdate') || '{}',
    );
    setRetainedEquipmentId(details.equipment_id ?? null);
    setAssetDetails({
      equipment_id: details.equipment_id,
      location_id: details.location_id,
      model_id: details.model_id,
      brand_id: details.brand_id,
      serial_number: details.serial_number,
      num_activo: details.num_activo,
    });

    if (!currentClient) {
      setVisitClientSites([]);
      setSelectedSite(null);
      return;
    }

    // The client's sites aren't embedded in visitClients, so they're fetched from the API.
    getVisitClientSites(currentClient.id).then((sites) => {
      setVisitClientSites(sites);
      setSelectedSite(sites.find((site) => site.id === currentSiteId) || null);
    });
  };

  function updateAsset(event) {
    event.preventDefault();
    var updateAssetId = localStorage.getItem('assetIdForUpdate');
    customAxios
      .patch(
        `${GlobalVariables.getURL()}updateAsset/${updateAssetId}`,
        {
          asset_name: name,
          description: description,
          site_id: siteId,
          ...assetDetails,
        },
        {
          headers: {
            Authorization: 'bearer ' + localStorage.getItem('token'),
          },
        },
      )
      .then(
        (response) => {
          console.log(response);
          //alert("Cliente actualizado exitosamente en la base de datos.");
          hide();
        },
        (error) => {
          getToast({
            status: 'error',
            title: 'Error al actualizar equipo. Vuelve a intentarlo.',
          });
          console.log(error);
        },
      );
  }

  function hide() {
    props.onHide();
    getToast({
      status: 'success',
      title: 'Equipo actualizado exitosamente en la base de datos.',
    });
    getAssets();
  }

  return (
    <Modal
      onEntering={resetFormFields}
      {...modalProps}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Editar equipo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form id="update-asset-form" onSubmit={updateAsset}>
          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label="Nombre del equipo"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>

          <br />

          <div className="row">
            <div className="col-md-6">
              <Autocomplete
                disablePortal
                includeInputInList={false}
                options={visitClients}
                value={selectedClient}
                sx={{ width: '100%' }}
                getOptionLabel={(option) => option?.business_name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccionar Plaza..."
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
                onChange={handleFirstSelection}
              />
            </div>
            <div className="col-md-6">
              <Autocomplete
                disablePortal
                includeInputInList={false}
                sx={{ width: '100%' }}
                options={visitClientSites}
                value={selectedSite}
                getOptionLabel={(option) => option?.site_name || ''}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Seleccionar sucursal..."
                    required
                    inputProps={{
                      ...params.inputProps,
                    }}
                  />
                )}
                onChange={(event, newValue) => {
                  setSelectedSite(newValue);
                  setSiteId(newValue?.id || null);
                }}
              />
            </div>
          </div>

          <br />

          <AssetCatalogFields
            show={props.show}
            value={assetDetails}
            onChange={setAssetDetails}
            retainedEquipmentId={retainedEquipmentId}
          />

          <br />

          <div className="row">
            <div className="col-md-12">
              <TextField
                sx={{ width: '100%' }}
                label={notesString}
                type="text"
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="submit"
          form="update-asset-form"
          className="update-modal-button"
        >
          Guardar cambios
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAUpdate;
